
import React from 'react';
import { usePersonaContext } from '@/contexts/PersonaContext';
import { AppNavbar } from '@/components/layout/AppNavbar';

const Admin = () => {
  const { currentPersona } = usePersonaContext();
  
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <AppNavbar />
      
      <main className="flex-1 container py-12">
        <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>
        <p className="text-xl">Welcome to the Admin interface!</p>
        <p className="mt-4">This is a placeholder page for the Admin persona.</p>
        <div className="mt-8 p-4 border rounded-lg bg-blue-50">
          <p className="font-medium">Current Persona: {currentPersona?.name}</p>
        </div>
      </main>
    </div>
  );
};

export default Admin;
